export default "__VITE_ASSET__HUH5qSrn__"